import { validations } from './validations';

const beerBrands = [
  { value: 'amstel 0.0', label: 'Amstel 0.0' },
  { value: 'brahma zero', label: 'Brahma Zero' },
  { value: 'budweiser zero', label: 'Budweiser Zero' },
  { value: 'corona cero', label: 'Corona Cero' },
  { value: 'erdinger weissbier sem álcool', label: 'Erdinger Weissbier Sem Álcool' },
  { value: 'estrella galicia 0.0', label: 'Estrella Galicia 0.0' },
  { value: 'etapp', label: 'Etapp' },
  { value: 'krug zero', label: 'Krug Zero' },
  { value: 'heineken zero', label: 'Heineken Zero' },
  { value: 'luci', label: 'Luci' },
  { value: 'sim!', label: 'SIM!' },
];
/**
 * Questions about non alcohol beer
 */
export const nonAlcoholBeerQuestions = [
  {
    id: 'non-alcohol-beer-opinion',
    question: 'Qual a sua opinião sobre cervejas sem álcool?',
    type: 'radio',
    options: [
      { value: 'acho bom', label: 'Acho bom' },
      { value: 'acho ruim', label: 'Acho ruim' },
      { value: 'não faz diferença pra mim', label: 'Não faz diferença pra mim' },
    ],
    validation: validations.required,
  },
  {
    id: 'non-alcohol-beer-consumption',
    question: 'Você já bebeu cervejas sem álcool?',
    type: 'radio',
    options: [
      { value: 'sim, e consumo com frequência', label: 'Sim, e consumo com frequência' },
      { value: 'já provei mas não costumo consumir', label: 'Já provei mas não costumo consumir' },
      { value: 'não, mas tenho interesse em experimentar', label: 'Não, mas tenho interesse em experimentar' },
      { value: 'não, e não tenho interesse em experimentar', label: 'Não, e não tenho interesse em experimentar' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'sim, e consumo com frequência' || answer === 'não, mas tenho interesse em experimentar') {
        return 'non-alcohol-beer-reasons';
      }
      return 'non-alcohol-beer-no-interest';
    },
    validation: validations.required,
  },
  {
    id: 'non-alcohol-beer-reasons',
    question: 'Por qual razão você gosta/bebe cervejas sem álcool ou tem interesse em provar?',
    type: 'checkbox',
    options: [
      { value: 'doenças / problemas de saúde', label: 'Doenças / problemas de saúde' },
      { value: 'lactante / gestante', label: 'Lactante / Gestante' },
      { value: 'quando vou dirigir', label: 'Quando vou dirigir' },
      { value: 'para reduzir meu consumo de álcool de uma maneira geral', label: 'Para reduzir meu consumo de álcool de uma maneira geral' },
      { value: 'para acompanhar outras pessoas', label: 'Para acompanhar outras pessoas' },
      { value: 'gosto do sabor', label: 'Gosto do sabor' },
      { value: 'não gosto de ficar bêbado(a) / alterado(a)', label: 'Não gosto de ficar bêbado(a) / alterado(a)' },
      { value: 'não prejudicar atividade esportiva', label: 'Não prejudicar atividade esportiva' },
      { value: 'religião', label: 'Religião' },
    ],
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
  },
  {
    id: 'non-alcohol-beer-dosage',
    question: 'Quando você bebe (ou pensa em experimentar) cerveja sem álcool, como ela entra na sua rotina de consumo?',
    type: 'radio',
    options: [
      { value: 'mesmas ocasiões em que eu beberia uma cerveja com álcool (substituição)', label: 'Mesmas ocasiões em que eu beberia uma cerveja com álcool (substituição)' },
      { value: 'novas ocasiões onde eu normalmente não beberia cerveja (ex: no trabalho, pós-treino, almoço profissional, em substituição a refrigerantes, etc)', label: 'Novas ocasiões onde eu normalmente não beberia cerveja (ex: No trabalho, pós-treino, almoço profissional, em substituição a refrigerantes, etc)' },
      { value: 'ambos: às vezes em substituição, e \as vezes em novas ocasiões', label: 'Ambos: Às vezes em substituição, e \as vezes em novas ocasiões' },
      { value: 'ainda estou explorando / não sei dizer', label: 'Ainda estou explorando / Não sei dizer' },
    ],
    allowOther: true,
    validation: validations.required
  },
  {
    id: 'non-alcohol-beer-brands',
    question: 'Quais das seguintes marcas de cerveja sem álcool você conhece ou já provou?',
    type: 'checkbox',
    options: beerBrands,
    allowOther: true,
    minSelections: 1,
    validation: validations.checkboxMinMax(1,999)
  },
  {
    id: 'non-alcohol-beer-favorites',
    question: 'E quais suas favoritas entre essas?',
    type: 'checkbox',
    options: beerBrands,
    allowOther: true,
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1,3),
    nextQuestion: 'beer-drinking-dosage'
  },
  {
    id: 'non-alcohol-beer-no-interest',
    question: 'Por qual razão você não consome ou não tem interesse em consumir mais?',
    type: 'checkbox',
    options: [
      { value: 'não gosto do sabor', label: 'Não gosto do sabor' },
      { value: 'gosto da sensação proporcionada pelo álcool', label: 'Gosto da sensação proporcionada pelo álcool' },
      { value: 'acho frescura', label: 'Acho frescura' },
      { value: 'acho difícil de encontrar', label: 'Acho difícil de encontrar' },
      { value: 'não gosto de destoar do grupo', label: 'Não gosto de destoar do grupo' },
      { value: 'acho muito caras', label: 'Acho muito caras' },
      { value: "prefiro outras bebidas sem álcool", label: "Prefiro outras bebidas sem álcool" },
      { value: "não acho para vender", label: "Não acho para vender" },
    ],
    minSelections: 1,
    maxSelections: 3,
    nextQuestion: (answer, allAnswers) => {
      if(allAnswers['non-alcohol-beer-consumption'] === 'não, e não tenho interesse em experimentar') {
        return 'beer-drinking-dosage';
      }
      return 'non-alcohol-beer-advices';
    },
    validation: validations.checkboxMinMax(1, 3),
  },
  {
    id: 'non-alcohol-beer-advices',
    question: 'O que poderia te levar a provar ou consumir mais cervejas sem álcool?',
    type: 'checkbox',
    options: [
      { value: 'adição de frutas', label: 'Adição de frutas' },
      { value: 'opções mais amargas', label: 'Opções mais amargas' },
      { value: 'disponibilidade nos locais onde costumo comprar ou consumir', label: 'Disponibilidade nos locais onde costumo comprar ou consumir' },
      { value: 'validação social (não ser mal visto ao consumir)', label: 'Validação social (não ser mal visto ao consumir)' },
      { value: 'preços mais baixos', label: 'Preços mais baixos' },
      { value: 'estilos ou sabores diferentes', label: 'Estilos ou sabores diferentes' },
    ],
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
    nextQuestion: 'beer-drinking-dosage',
  }
];
